import {Component, OnInit} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {CheckhrService} from '../service/checkhr.service';
import {BusyProvider} from '../service/busy.service';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, ElCheckhr} from '../core/core.component';
import {Message} from 'primeng/components/common/api';

@Component({
  selector: 'app-checkhr-defs',
  templateUrl: './checkhr-defs.component.html',
  styleUrls: ['./checkhr-defs.component.css'],
})
export class CheckhrDefsComponent extends BaseComponent implements OnInit {

  userContext: UserContext;
  checkhrs: ElCheckhr[] = [];
  loading = false;
  filteredCheckhrs: ElCheckhr[] = [];
  filterQuery = '';
  checkhrSelected: ElCheckhr = new ElCheckhr();
  validationMessage: string = null;
  showDeleteAlert = false;

  checkhrId: number = null;
  checkhrDesc = '';
  checkhrNumGiorniValidita: number = null;
  checkhrNumGiorniAlert: number = null;

  msgs: Message[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private checkhrService: CheckhrService,
    private busyProvider: BusyProvider) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.loadCheckhr();
    }
  }

  filterCheckhrs() {
    this.filteredCheckhrs = this.checkhrs;
    if (this.filterQuery != null && this.filterQuery.trim() !== '') {
      this.filteredCheckhrs = [];
      for (let i = 0; i < this.checkhrs.length; ++i) {
        if (this.checkhrs[i].desc.toLowerCase().indexOf(this.filterQuery.toLowerCase()) >= 0) {
          this.filteredCheckhrs.push(this.checkhrs[i]);
        }
      }
    }
    if (this.filteredCheckhrs.length === 1) {
      this.checkhrSelected = this.filteredCheckhrs[0];
      this.selectCheckhr(this.checkhrSelected);
    }
  }

  loadCheckhr() {
    this.checkhrs = [];
    this.loading = true;
    this.checkhrService.getCheckhrElements(this.userContext.srmToken).subscribe(
      result => {
        this.checkhrs = result.elements;
        this.loading = false;
        if (this.checkhrSelected != null && this.checkhrSelected.id > 0) {
          this.selectCheckhr(this.checkhrSelected);
        }
        this.filterCheckhrs();
      },
      error => {
        this.handleError(error);
        this.loading = false;
      });
  }

  selectCheckhr(checkhr: ElCheckhr) {
    this.validationMessage = null;
    this.checkhrSelected = checkhr;
    this.checkhrId = checkhr.id;
    this.checkhrDesc = checkhr.desc;
    this.checkhrNumGiorniValidita = checkhr.numGiorniValidita;
    this.checkhrNumGiorniAlert = checkhr.numGiorniAlert;
  }

  addNewCheckhr() {
    this.validationMessage = null;
    this.messageProvider.clearAll();
    this.checkhrSelected = new ElCheckhr();
    this.checkhrId = null;
    this.checkhrDesc = null;
    this.checkhrNumGiorniValidita = null;
    this.checkhrNumGiorniAlert = null;
  }

  storeCheckhr() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    if (this.checkhrDesc == null || this.checkhrDesc.length === 0) {
      this.validationMessage = 'Inserire la descrizione';
      return;
    }
    if (this.checkhrNumGiorniValidita == null) {
      this.validationMessage = 'Inserire il numero di giorni di validita\'';
      return;
    } else if (this.checkhrNumGiorniValidita <= 0) {
      this.validationMessage = 'Il numero di giorni di validita\' deve essere maggiore di 0';
      return;
    }
    if (this.checkhrNumGiorniAlert == null) {
      this.validationMessage = 'Inserire il numero di giorni di alert';
      return;
    } else if (this.checkhrNumGiorniAlert <= 0) {
      this.validationMessage = 'Il numero di giorni di alert deve essere maggiore di 0';
      return;
    } else if (this.checkhrNumGiorniAlert >= this.checkhrNumGiorniValidita) {
      this.validationMessage = 'Il numero di giorni di alert deve essere minore al numero di giorni di validita\'';
      return;
    }

    // modifica
    if (this.checkhrSelected.id > 0) {
      this.busyProvider.showBusyIndicator();
      this.checkhrService.updateCheckhrElement(this.userContext.srmToken, this.checkhrId, this.checkhrDesc, this.checkhrNumGiorniValidita, this.checkhrNumGiorniAlert).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Modifica eseguita correttamente'});
          this.checkhrSelected = this.buildElCheckhr(this.checkhrId, this.checkhrDesc, this.checkhrNumGiorniValidita, this.checkhrNumGiorniAlert);
          this.loadCheckhr();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    } else { // inserimento
      this.busyProvider.showBusyIndicator();
      this.checkhrService.insertCheckhrElement(this.userContext.srmToken, this.checkhrDesc, this.checkhrNumGiorniValidita, this.checkhrNumGiorniAlert).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Scadenza inserita correttamente'});
          this.checkhrId = Number(result.id);
          this.checkhrSelected = this.buildElCheckhr(this.checkhrId, this.checkhrDesc, this.checkhrNumGiorniValidita, this.checkhrNumGiorniAlert);
          this.loadCheckhr();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    }
  }

  buildElCheckhr(id, desc, numGiorniValidita, numGiorniAlert) {
    const checkhr: ElCheckhr = new ElCheckhr();
    checkhr.id = id;
    checkhr.desc = desc;
    checkhr.numGiorniValidita = numGiorniValidita;
    checkhr.numGiorniAlert = numGiorniAlert;
    return checkhr;
  }

  openDeleteAlert(current: ElCheckhr) {
    this.selectCheckhr(current);
    this.showDeleteAlert = true;
  }
  closeDeleteAlert() {
    this.showDeleteAlert = false;
  }

  deleteCheckhr() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    this.busyProvider.showBusyIndicator();
    this.checkhrService.deleteCheckhrElement(this.userContext.srmToken, this.checkhrId).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
        this.addNewCheckhr();
        this.loadCheckhr();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/checkhr-defs/checkhr-defs.component.ts